module.exports = __webpack_public_path__ + "common/sidebar/icon-mail-bulk-61b4d631a573dd57e817593995926400.svg";